// extracted by mini-css-extract-plugin
export default {"statGroup":"StatCard_statGroup__jAaGl","stat":"StatCard_stat__+FceC","value":"StatCard_value__Pmuin","tag":"StatCard_tag__RcMdc","description":"StatCard_description__pepgb"};